<template>
  <div class="d-none d-sm-block col-sm-12 col-lg-6">
    <div class="h-xs-__ hidden-lg" />
    <img
      class="person-img"
      src="https://storage.googleapis.com/ahrtalwebseitendb/website/725dc906-dominik_neswadba-geschaeftsfuehrer.png"
      alt="Dominik Neswadba"
    >
    <p class="pl-lg-4">
      <span class="text-nowrap">
        <b>Dominik Neswadba</b>
        <a href="/unternehmen/ansprechpartner/#dominikneswadba">
          <i class="fas fa-info-circle" />
        </a>
      </span>
      <br>Geschäftsführer
    </p>
  </div>
</template>
